(function() { window.GUID_7f563f1f_e7da_4966_b84d_d85333d7c028 = { getGuid: function() { return "7f563f1f-e7da-4966-b84d-d85333d7c028"; } }; })();
var CS;
(function (CS) {
    var Helper;
    (function (Helper) {
        function fetchAndPrependToTarget(props) {
            const { url, targetSelector } = props;
            if (!url || !targetSelector)
                return;
            const $target = $(targetSelector);
            if (!$target.length)
                return;
            //Ajax.Get(
            //    url,
            //    {},
            //    (response) => {
            //        const $svgElement = $(response);
            //        $target.prepend($svgElement);
            //    },
            //    (extraParameters) => {
            //        extraParameters.doubleCallAllowed = true;
            //    }
            //);
            fetch(url)
                .then((response) => {
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                return response.text();
            })
                .then((responseText) => {
                const $response = $(responseText);
                $target.prepend($response);
            })
                .catch((error) => {
                console.error("Error fetching:", error);
            });
        }
        Helper.fetchAndPrependToTarget = fetchAndPrependToTarget;
        function gZipCompress(value) {
            return new Promise((resolve, reject) => {
                const url = CS.Url.CSUrl("GZipCompress");
                if (!url) {
                    reject("GZipCompress url not found");
                }
                CS.Ajax.Post(url, { value }, (response) => {
                    resolve(response === null || response === void 0 ? void 0 : response.result);
                });
            });
        }
        Helper.gZipCompress = gZipCompress;
        function gZipDecompress(value) {
            return new Promise((resolve, reject) => {
                const url = CS.Url.CSUrl("GZipDecompress");
                if (!url) {
                    reject("GZipDecompress url not found");
                }
                CS.Ajax.Post(url, { value }, (response) => {
                    resolve(response === null || response === void 0 ? void 0 : response.result);
                });
            });
        }
        Helper.gZipDecompress = gZipDecompress;
        function setKendoCulture(langCode) {
            try {
                if (typeof window.kendo === "undefined") {
                    throw new Error("Kendo is not loaded");
                }
                switch (langCode.toLowerCase()) {
                    case "fr":
                        if (window.setKendoCultureToFrench) {
                            window.setKendoCultureToFrench();
                        }
                        break;
                    case "es":
                        if (window.setKendoCultureToSpanish) {
                            window.setKendoCultureToSpanish();
                        }
                        break;
                    case "fi":
                        if (window.setKendoCultureToFinnish) {
                            window.setKendoCultureToFinnish();
                        }
                        break;
                    case "da":
                        if (window.setKendoCultureToDanish) {
                            window.setKendoCultureToDanish();
                        }
                        break;
                    case "en":
                    default:
                        if (window.setKendoCultureToEnglish) {
                            window.setKendoCultureToEnglish();
                        }
                        break;
                }
            }
            catch (error) {
                console.error("Error while setting kendo culture", error);
            }
        }
        Helper.setKendoCulture = setKendoCulture;
        function decodeHTMLEntities(text) {
            const textArea = document.createElement("textarea");
            textArea.innerHTML = text;
            return textArea.value;
        }
        Helper.decodeHTMLEntities = decodeHTMLEntities;
        /**
         * Works the same way as the C# string.Format method by replacing the placeholders in the template string with the values passed by searching for the {index} pattern.
         * @param template The template string in which the values will be inserted
         * @param values The values to insert in the template string. The values will be inserted in the order they are passed. If a value is not found in the template string, it will be ignored.
         * @returns The formatted string
         */
        function formatString(template, ...values) {
            return template.replace(/{(\d+)}/g, (match, index) => {
                return typeof values[index] !== "undefined" ? values[index] : match;
            });
        }
        Helper.formatString = formatString;
        function removeWhiteSpaces(text) {
            return text.replace(/\s+/g, "");
        }
        Helper.removeWhiteSpaces = removeWhiteSpaces;
        function AddSuffixToDay(date, stringDate, removeMonthFormat) {
            var _a, _b;
            const lang = (_b = (_a = CS.CommonData === null || CS.CommonData === void 0 ? void 0 : CS.CommonData.Current) === null || _a === void 0 ? void 0 : _a.Language) !== null && _b !== void 0 ? _b : "en";
            const isEnglish = lang.toLowerCase() == "en";
            if (!isEnglish) {
                return stringDate;
            }
            const day = date.getDate();
            const suffix = GetDaySuffix(day);
            let result = stringDate.replace(day.toString(), day + suffix);
            if (removeMonthFormat) {
                const longMonths = [
                    "January",
                    "February",
                    "March",
                    "April",
                    "May",
                    "June",
                    "July",
                    "August",
                    "September",
                    "October",
                    "November",
                    "December",
                ];
                const shortMonths = [
                    "Jan",
                    "Feb",
                    "Mar",
                    "Apr",
                    "May",
                    "Jun",
                    "Jul",
                    "Aug",
                    "Sep",
                    "Oct",
                    "Nov",
                    "Dec",
                ];
                if (removeMonthFormat == "long") {
                    longMonths.forEach((month, index) => {
                        result = result.replace(month, "");
                    });
                }
                else if (removeMonthFormat == "short") {
                    shortMonths.forEach((month, index) => {
                        result = result.replace(month, "");
                    });
                }
            }
            return result;
        }
        Helper.AddSuffixToDay = AddSuffixToDay;
        function GetDaySuffix(day) {
            let suffix = "th";
            if (day > 3 && day < 21)
                suffix = "th";
            else
                switch (day % 10) {
                    case 1:
                        suffix = "st";
                        break;
                    case 2:
                        suffix = "nd";
                        break;
                    case 3:
                        suffix = "rd";
                        break;
                    default:
                        suffix = "th";
                }
            return suffix;
        }
        function log(name, ...args) {
            var _a, _b;
            if ((_b = (_a = CS.CommonData === null || CS.CommonData === void 0 ? void 0 : CS.CommonData.Current) === null || _a === void 0 ? void 0 : _a.IsDebug()) !== null && _b !== void 0 ? _b : false) {
                console.debug(`%c${name}`, "background: #222; color: #55DA56", ...args);
            }
        }
        Helper.log = log;
        function logWithColor(name, color, ...args) {
            var _a, _b;
            if ((_b = (_a = CS.CommonData === null || CS.CommonData === void 0 ? void 0 : CS.CommonData.Current) === null || _a === void 0 ? void 0 : _a.IsDebug()) !== null && _b !== void 0 ? _b : false) {
                console.debug(`%c${name}`, `background: #222; color: ${color}`, ...args);
            }
        }
        Helper.logWithColor = logWithColor;
        function IsPartiallyInView($element, topHeight, bottomHeight) {
            if (!$element.length) {
                return false;
            }
            if (topHeight == null) {
                topHeight = 0;
            }
            if (bottomHeight == null) {
                bottomHeight = 0;
            }
            const rect = $element[0].getBoundingClientRect();
            const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
            const adjustedViewportHeight = viewportHeight - (topHeight + bottomHeight);
            const isTopEdgeVisible = rect.top <= adjustedViewportHeight && rect.top >= topHeight;
            const isBottomEdgeVisible = rect.bottom >= -topHeight && rect.bottom <= adjustedViewportHeight;
            const isPartiallyVisible = isTopEdgeVisible || isBottomEdgeVisible;
            return isPartiallyVisible;
        }
        Helper.IsPartiallyInView = IsPartiallyInView;
        function SetTopbarBackgroundImage(imageUrl, blurred) {
            try {
                if (Helper.isNullOrWhiteSpace(imageUrl)) {
                    return;
                }
                const $sectionTop = $("#section-top");
                if (!$sectionTop.length) {
                    return;
                }
                // append new div with background image. Should be absolute positioned and z-indexed behind the topbar
                let $sectionTopBackground = $sectionTop.find("#section-top-background");
                if (!$sectionTopBackground.length) {
                    // <div id="topbar-background-image" class="topbar-background-image"></div>
                    $sectionTop.append(`<div id="section-top-background" class="section-top-background">
            <canvas id="topbar-background-image" class="topbar-background-image"></canvas>
          </div>`);
                    $sectionTopBackground = $sectionTop.find("#section-top-background");
                }
                if (!$sectionTopBackground.length) {
                    return;
                }
                const $secitonTopBackgroundImage = $sectionTopBackground.find("#topbar-background-image");
                const shouldBlur = blurred == "True";
                $sectionTopBackground.css({
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    "z-index": -1,
                    overflow: "hidden",
                    opacity: shouldBlur ? 0.5 : 1,
                    display: "flex",
                    "align-items": "center",
                    "justify-content": "center",
                    //transform: "translateX(-50%)",
                });
                if (!$secitonTopBackgroundImage.length) {
                    return;
                }
                $secitonTopBackgroundImage.css({
                    // "background-image": `url(${imageUrl})`,
                    // "background-size": "cover",
                    // "background-position": "center",
                    // "background-repeat": "no-repeat",
                    // filter: shouldBlur ? "blur(10px)" : "none",
                    width: "100%",
                    height: "100%",
                });
                const canvas = $secitonTopBackgroundImage[0];
                const context = canvas.getContext("2d");
                if (CS.CommonData.Current.BrowserSupportsCanvasAPIFilterProperty) {
                    context.filter = shouldBlur ? "blur(50px)" : "none";
                }
                else {
                    $secitonTopBackgroundImage.css({
                        filter: shouldBlur ? "blur(50px)" : "none",
                    });
                }
                const image = new Image();
                image.src = imageUrl;
                image.onload = () => {
                    context.drawImage(image, 0, 0, canvas.width, canvas.height);
                };
            }
            catch (error) {
                console.error("SetTopbarBackgroundImage", error);
            }
        }
        Helper.SetTopbarBackgroundImage = SetTopbarBackgroundImage;
        function ShowCSRChangelogSummaryModal() {
            CS.Lag("ShowCSRChangelogSummaryModal", 500, () => {
                const url = CS.Url.CSUrl("CSRChangelogSummaryModal");
                const onCloseUrl = CS.Url.CSUrl("InsertActionDone");
                if (!url || !onCloseUrl) {
                    console.error("An url for CSRChangelogSummaryModal was not found");
                    return;
                }
                CS.Controls.Popup.ShowAjaxModal(url, {}, ({ popup, isPopup }) => {
                    if (!isPopup) {
                        return;
                    }
                    // On show modal
                    const $header = popup.$Control.find(".csr-changelog-summary-modal__header");
                    const $title = $header.find(".title");
                    const $subtitle = $header.find(".subtitle");
                    const $body = popup.$Control.find(".csr-changelog-summary-modal__body");
                    const $content = $body.find(`[class*="content-"]`);
                    const $footer = popup.$Control.find(".csr-changelog-summary-modal__footer");
                    const $stepper = $footer.find(".stepper");
                    const $steps = $stepper.find(`[class*="step-"]`);
                    const $skipButton = $footer.find("#button-csr-changelog-summary-skip");
                    const $continueButton = $footer.find("#button-csr-changelog-summary-continue");
                    const $closeButton = popup.$Control.find("#button-csr-changelog-summary-close");
                    if (!$header.length ||
                        !$title.length ||
                        !$subtitle.length ||
                        !$body.length ||
                        !$footer.length ||
                        !$stepper.length ||
                        !$steps.length ||
                        !$skipButton.length ||
                        !$continueButton.length ||
                        !$closeButton.length) {
                        console.error("CSRChangelogSummaryModal: required JQuery elements not found");
                        return;
                    }
                    let currentStep = 0;
                    $skipButton.offon("click.SRChangelogSummaryModal-skip", (e) => {
                        popup.Close();
                    });
                    $continueButton.offon("click.SRChangelogSummaryModal-skip", (e) => {
                        const nextStep = currentStep + 1;
                        const $nextContent = $content.filter(`.content-${nextStep.toString()}`);
                        const $nextStep = $stepper.find(`.step-${nextStep.toString()}`);
                        let thereIsNextStep = $nextContent.length && $nextStep.length;
                        if (thereIsNextStep) {
                            // There's a next step
                            // TODO: Add transitions
                            CS.Helper.enableButton($skipButton);
                            $skipButton.removeClass("hidden");
                            CS.Helper.enableButton($continueButton);
                            $continueButton.removeClass("hidden");
                            CS.Helper.disableButton($closeButton);
                            $closeButton.addClass("hidden");
                            const $currentContent = $content.filter(`.content-${currentStep.toString()}`);
                            const $currentStep = $stepper.find(`.step-${currentStep.toString()}`);
                            if (!$currentContent.length || !$currentStep.length) {
                                console.error("CSRChangelogSummaryModal: current step not found");
                                return;
                            }
                            $currentStep.removeClass("circle__filled");
                            $currentStep.addClass("circle__hollow");
                            $nextStep.addClass("circle__filled");
                            $nextStep.removeClass("circle__hollow");
                            $currentContent.animate({
                                opacity: 0,
                            }, 250, () => {
                                $nextContent.css({ opacity: 0 });
                                $nextContent.show();
                                $currentContent.hide();
                                $nextContent.animate({
                                    opacity: 1,
                                }, 250, () => { });
                            });
                            currentStep = nextStep;
                            thereIsNextStep =
                                $content.filter(`.content-${(currentStep + 1).toString()}`)
                                    .length &&
                                    $stepper.find(`.step-${(currentStep + 1).toString()}`).length;
                        }
                        if (!thereIsNextStep) {
                            // There's no next step
                            CS.Helper.disableButton($skipButton);
                            $skipButton.addClass("hidden");
                            CS.Helper.disableButton($continueButton);
                            $continueButton.addClass("hidden");
                            CS.Helper.enableButton($closeButton);
                            $closeButton.removeClass("hidden");
                        }
                    });
                    $closeButton.offon("click.SRChangelogSummaryModal-skip", (e) => {
                        popup.Close();
                    });
                }, (p) => {
                    // On close modal
                    console.log(CS.Enumeration.UserActionsToDoTemplate.CSRChangelogSummary);
                    CS.Ajax.Post(onCloseUrl, { id: CS.Enumeration.UserActionsToDoTemplate.CSRChangelogSummary }, (response) => { });
                }, true);
            });
        }
        Helper.ShowCSRChangelogSummaryModal = ShowCSRChangelogSummaryModal;
        function ShowSubscribedToPremiumPopup() {
            try {
                const url = CS.Url.CSUrl("ShowSubscribedToPremiumModal");
                const insertActionDonesUrl = CS.Url.CSUrl("InsertActionsDone");
                let ids = `${CS.Enumeration.UserActionsToDoTemplate.SubscribedToPremium}`;
                if (insertActionDonesUrl != null) {
                    CS.Controls.Popup.ShowAjaxModal(url, null, ({ popup, isPopup }) => {
                        if (isPopup) {
                            popup.$Control.offon("click.discoverFeaturesFromModal", "#button-subscribed-to-premium-modal", (e) => {
                                popup.Proceed = true;
                                popup.Close();
                            });
                        }
                        CS.Ajax.Post(insertActionDonesUrl, { ids }, (response) => {
                            console.log(response);
                        });
                    }, ({ popup }) => { }, true);
                }
            }
            catch (e) {
                console.error(e);
            }
        }
        Helper.ShowSubscribedToPremiumPopup = ShowSubscribedToPremiumPopup;
        function generateRandomId(length = 36) {
            var result = "";
            var characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
            var charactersLength = characters.length;
            for (var i = 0; i < length; i++) {
                if (i == 0) {
                    // First character must be a letter (upper or lower case)
                    // to avoid problems with jQuery selectors
                    result += characters.charAt(Math.floor(Math.random() * 52));
                    continue;
                }
                result += characters.charAt(Math.floor(Math.random() * charactersLength));
            }
            return result;
        }
        Helper.generateRandomId = generateRandomId;
        function ShowCSRDisabledMessage(params) {
            const { containerId, divisionName } = params;
            const $container = $(`#${containerId}`);
            if (!$container.length)
                return;
            const titleHtml = JSRess.TheCSRIsDisabledInThisDivision;
            let messageHtml = Helper.formatString(JSRess.TheResultsOfTheMatchesYouPlayInThisDivisionDoNotAffectYourCSR, divisionName);
            messageHtml += JSRess.ForMoreInformationContactTheEventManager;
            const containerStyle = `
        background-color: rgba(255,255,255,0.05);
        border: 1px solid rgba(255,255,255,0.1);
        border-radius: 0.5em;
        text-align: center;
        font-style: italic;
        color: white; 
        max-width: 500px;
        padding: 8px; 
        margin: 8px auto; 
        font-size: 0.8em; 
      `;
            const titleStyle = "";
            const messageStyle = `
        font-size: 0.8em;
        opacity: 0.6;
      `;
            $container.html(`
        <div style="${containerStyle}">
            <div style="${titleStyle}">${titleHtml}</div>
            <div style="${messageStyle}">${messageHtml}</div>
        </div>
        `);
        }
        Helper.ShowCSRDisabledMessage = ShowCSRDisabledMessage;
        function ShowLoader({ id, $container, autoRemoveDelay, overContent, position, }) {
            const _$container = $container();
            if (_$container.length) {
                if (overContent) {
                    _$container.addClass("cs-loader-container");
                }
                if (position == "prepend") {
                    _$container.prepend(`<div id="${id}" class="cs-loader"><div class="cs-loader-inner-content"></div></div>`);
                }
                else {
                    _$container.append(`<div id="${id}" class="cs-loader"><div class="cs-loader-inner-content"></div></div>`);
                }
                if (autoRemoveDelay != null) {
                    CS.Lag(id, autoRemoveDelay, () => {
                        $container().find(`#${id}`).remove();
                    });
                }
            }
        }
        Helper.ShowLoader = ShowLoader;
        function RemoveLoader({ id, $container, }) {
            var _a;
            $(`#${id}.cs-loader`).remove();
            if ((_a = $container === null || $container === void 0 ? void 0 : $container.length) !== null && _a !== void 0 ? _a : 0) {
                $container.removeClass("cs-loader-container");
            }
        }
        Helper.RemoveLoader = RemoveLoader;
        class StatefulValue {
            constructor(defaultValue) {
                this.value = defaultValue;
                this.initialValue = defaultValue;
            }
            setValue(value) {
                this.value = value;
            }
            resetValue() {
                this.value = this.initialValue;
            }
        }
        Helper.StatefulValue = StatefulValue;
        class StatefulNumber extends StatefulValue {
            incrementValue(value = 1) {
                this.value += value;
            }
            decrementValue(value = 1) {
                this.value -= value;
            }
        }
        Helper.StatefulNumber = StatefulNumber;
        function GetWallTypeString(wallType) {
            switch (wallType) {
                case CS.Enumeration.WallType.AwardsWall:
                    return "AwardsWall";
                case CS.Enumeration.WallType.BracketWall:
                    return "BracketWall";
                case CS.Enumeration.WallType.DivisionsWall:
                    return "DivisionsWall";
                case CS.Enumeration.WallType.DivisionWall:
                    return "DivisionWall";
                case CS.Enumeration.WallType.EventsWall:
                    return "EventsWall";
                case CS.Enumeration.WallType.EventsWallV2:
                    return "EventsWallV2";
                case CS.Enumeration.WallType.EventWall:
                    return "EventWall";
                case CS.Enumeration.WallType.Friends:
                    return "Friends";
                case CS.Enumeration.WallType.GamesWall:
                    return "GamesWall";
                case CS.Enumeration.WallType.GameHistoryWall:
                    return "GameHistoryWall";
                case CS.Enumeration.WallType.Home:
                    return "Home";
                case CS.Enumeration.WallType.Leaderboard:
                    return "Leaderboard";
                case CS.Enumeration.WallType.Landing:
                    return "Landing";
                case CS.Enumeration.WallType.MatchCard:
                    return "MatchCard";
                case CS.Enumeration.WallType.MatchDetails:
                    return "MatchDetails";
                case CS.Enumeration.WallType.Matches:
                    return "Matches";
                case CS.Enumeration.WallType.MainMenu:
                    return "MainMenu";
                case CS.Enumeration.WallType.Messages:
                    return "Messages";
                case CS.Enumeration.WallType.None:
                    return "None";
                case CS.Enumeration.WallType.OperatorWall:
                    return "OperatorWall";
                case CS.Enumeration.WallType.OperatorsWall:
                    return "OperatorsWall";
                case CS.Enumeration.WallType.Other:
                    return "Other";
                case CS.Enumeration.WallType.Opponents:
                    return "Opponents";
                case CS.Enumeration.WallType.OpponentsWall:
                    return "OpponentsWall";
                case CS.Enumeration.WallType.PersonaWall:
                    return "PersonaWall";
                case CS.Enumeration.WallType.PinsWall:
                    return "PinsWall";
                case CS.Enumeration.WallType.RankingsWall:
                    return "RankingsWall";
                case CS.Enumeration.WallType.SchedulesFinder:
                    return "SchedulesFinder";
                case CS.Enumeration.WallType.Settings:
                    return "Settings";
                case CS.Enumeration.WallType.SportsWall:
                    return "SportsWall";
                case CS.Enumeration.WallType.StatsCompareWall:
                    return "StatsCompareWall";
                case CS.Enumeration.WallType.StatsWall:
                    return "StatsWall";
                case CS.Enumeration.WallType.TeamCompareWall:
                    return "TeamCompareWall";
                case CS.Enumeration.WallType.TeamMembers:
                    return "TeamMembers";
                case CS.Enumeration.WallType.TeamsCompareWall:
                    return "TeamsCompareWall";
                case CS.Enumeration.WallType.TeamsWall:
                    return "TeamsWall";
                case CS.Enumeration.WallType.VideoStreams:
                    return "VideoStreams";
                default:
                    return "-";
            }
        }
        Helper.GetWallTypeString = GetWallTypeString;
        class GoogleAnalyticsHelper {
            static get instance() {
                if (!GoogleAnalyticsHelper._instance)
                    GoogleAnalyticsHelper._instance = new GoogleAnalyticsHelper();
                return GoogleAnalyticsHelper._instance;
            }
            constructor() {
                this.dictionary = {};
            }
            static registerData(key, category, action, label, value) {
                const { instance } = GoogleAnalyticsHelper;
                const $element = CS.DOM.$body.find(`[data-ga-data-key="${key}"]`);
                if ($element.length) {
                    $element.append(`<input class="data-ga-data-key" type="hidden" data-value="${key}"/>`);
                    instance.dictionary[key] = {
                        category,
                        action,
                        label,
                        value,
                    };
                }
            }
            static getDataFromElement($element) {
                try {
                    const $hiddenInput = $element.find(".data-ga-data-key");
                    const key = $hiddenInput.data("value") || $element.data("ga-data-key");
                    const data = GoogleAnalyticsHelper.instance.dictionary[key];
                    const { category, action, label, value } = data;
                    const valueIsNumber = Number.isInteger(value);
                    const valueIsValid = typeof value === "undefined" || valueIsNumber;
                    return {
                        category,
                        action,
                        label,
                        value,
                        isValid: category.length > 0 && action.length > 0 && valueIsValid,
                    };
                }
                catch (error) {
                    console.error(error);
                    return {
                        isValid: false,
                        category: "",
                        action: "",
                        label: "",
                        value: 0,
                    };
                }
            }
        }
        Helper.GoogleAnalyticsHelper = GoogleAnalyticsHelper;
        class DataVisualizationHelper {
            static get instance() {
                if (!DataVisualizationHelper._instance)
                    DataVisualizationHelper._instance = new DataVisualizationHelper();
                return DataVisualizationHelper._instance;
            }
            static get divergentPaletteColorsCount() {
                const { DIVERGENT_PALETTE } = DataVisualizationHelper;
                return Object.keys(DIVERGENT_PALETTE).length;
            }
            constructor() { }
            static getColors(length) {
                const { MAIN_COLOR, MUI_PALETTE, DIVERGENT_PALETTE, divergentPaletteColorsCount, } = DataVisualizationHelper;
                if (length <= 0) {
                    return [];
                }
                else if (length == 1) {
                    return [MAIN_COLOR];
                }
                else if (length <= divergentPaletteColorsCount) {
                    return Object.keys(DIVERGENT_PALETTE)
                        .map((key) => DIVERGENT_PALETTE[key])
                        .slice(0, length);
                }
                else {
                    //throw new Error("Not enough colors.");
                    console.error("Not enough colors.");
                    return Array.from({ length }, () => "rgba(255,255,255,0.5)");
                }
            }
            static getContinuousColors(params) {
                const { count, palettes, exclude } = params;
                const { CONTINUOUS_PALETTE } = DataVisualizationHelper;
                const continuousColors = [];
                while (continuousColors.length < count) {
                    palettes.forEach((palette) => {
                        Object.keys(CONTINUOUS_PALETTE).forEach((key) => {
                            if (!exclude || !exclude.includes(key)) {
                                continuousColors.push(CONTINUOUS_PALETTE[key][palette]);
                            }
                        });
                    });
                }
                return continuousColors;
            }
            static getStatColors(params) {
                const { stat, count } = params;
                const { BRIGHTNESS_LEVELS } = DataVisualizationHelper;
                const statColors = [];
                let palettes = [];
                switch (stat) {
                    case "Average":
                        palettes = ["teal", "lightBlue", "indigo"];
                        if (count == 1) {
                            palettes = ["teal"];
                        }
                        break;
                    case "CompuSportRating":
                        palettes = ["yellow", "orange", "red"];
                        //palettes = ["yellow", "orange", "red", "purple"];
                        //palettes = ["yellow", "orange", "red", "purple", "blue"];
                        if (count == 1) {
                            palettes = ["yellow"];
                        }
                        break;
                    case "Differential":
                        palettes = ["indigo", "lightBlue", "teal"];
                        if (count == 1) {
                            palettes = ["indigo"];
                        }
                        break;
                    case "WinPercent":
                    case "EncounterOpponentsScore":
                    case "Score":
                        palettes = ["teal", "green", "lime"];
                        if (count == 1) {
                            palettes = ["green"];
                        }
                        break;
                    case "EncounterOpponentsScore_Adv":
                    case "Score_Adv":
                        palettes = ["deepOrange", "red", "purple"];
                        if (count == 1) {
                            palettes = ["red"];
                        }
                        break;
                    case "TCSR":
                        palettes = ["yellow", "orange", "red"];
                        if (count == 1) {
                            palettes = ["yellow"];
                        }
                        break;
                    default:
                        palettes = ["yellow", "orange", "red"];
                        if (count == 1) {
                            palettes = ["yellow"];
                        }
                        break;
                }
                try {
                    let alreadyIncludedBrightnessLevels = [];
                    if (count == 1 && stat == "TCSR") {
                        return [DataVisualizationHelper.CONTINUOUS_PALETTE[100][palettes[0]]];
                    }
                    while (statColors.length < count) {
                        let brightnessLevel = BRIGHTNESS_LEVELS.find((level) => !alreadyIncludedBrightnessLevels.includes(level));
                        if (!brightnessLevel) {
                            alreadyIncludedBrightnessLevels = [];
                            brightnessLevel = BRIGHTNESS_LEVELS.find((level) => !alreadyIncludedBrightnessLevels.includes(level));
                        }
                        palettes.forEach((palette) => {
                            statColors.push(DataVisualizationHelper.CONTINUOUS_PALETTE[brightnessLevel][palette]);
                        });
                        alreadyIncludedBrightnessLevels.push(brightnessLevel);
                    }
                    if (params.includeBrightVariantIfCountIsOne && count == 1) {
                        statColors.push(DataVisualizationHelper.CONTINUOUS_PALETTE[300][palettes[palettes.length - 1]]);
                    }
                }
                catch (e) {
                    console.error(e);
                }
                return statColors;
            }
        }
        DataVisualizationHelper.MAIN_COLOR = "#FAAF17";
        DataVisualizationHelper.DEFAULT_COLOR = "#86849a";
        DataVisualizationHelper.MUI_PALETTE = {
            red: {
                100: "#ffcdd2",
                200: "#ef9a9a",
                300: "#e57373",
                400: "#ef5350",
                500: "#f44336",
                600: "#e53935",
                700: "#d32f2f",
                800: "#c62828",
                900: "#b71c1c",
            },
            pink: {
                100: "#f8bbd0",
                200: "#f48fb1",
                300: "#f06292",
                400: "#ec407a",
                500: "#e91e63",
                600: "#d81b60",
                700: "#c2185b",
                800: "#ad1457",
                900: "#880e4f",
            },
            purple: {
                100: "#e1bee7",
                200: "#ce93d8",
                300: "#ba68c8",
                400: "#ab47bc",
                500: "#9c27b0",
                600: "#8e24aa",
                700: "#7b1fa2",
                800: "#6a1b9a",
                900: "#4a148c",
            },
            deepPurple: {
                100: "#d1c4e9",
                200: "#b39ddb",
                300: "#9575cd",
                400: "#7e57c2",
                500: "#673ab7",
                600: "#5e35b1",
                700: "#512da8",
                800: "#4527a0",
                900: "#311b92",
            },
            indigo: {
                100: "#c5cae9",
                200: "#9fa8da",
                300: "#7986cb",
                400: "#5c6bc0",
                500: "#3f51b5",
                600: "#3949ab",
                700: "#303f9f",
                800: "#283593",
                900: "#1a237e",
            },
            blue: {
                100: "#bbdefb",
                200: "#90caf9",
                300: "#64b5f6",
                400: "#42a5f5",
                500: "#2196f3",
                600: "#1e88e5",
                700: "#1976d2",
                800: "#1565c0",
                900: "#0d47a1",
            },
            lightBlue: {
                100: "#b3e5fc",
                200: "#81d4fa",
                300: "#4fc3f7",
                400: "#29b6f6",
                500: "#03a9f4",
                600: "#039be5",
                700: "#0288d1",
                800: "#0277bd",
                900: "#01579b",
            },
            cyan: {
                100: "#b2ebf2",
                200: "#80deea",
                300: "#4dd0e1",
                400: "#26c6da",
                500: "#00bcd4",
                600: "#00acc1",
                700: "#0097a7",
                800: "#00838f",
                900: "#006064",
            },
            teal: {
                100: "#b2dfdb",
                200: "#80cbc4",
                300: "#4db6ac",
                400: "#26a69a",
                500: "#009688",
                600: "#00897b",
                700: "#00796b",
                800: "#00695c",
                900: "#004d40",
            },
            green: {
                100: "#c8e6c9",
                200: "#a5d6a7",
                300: "#81c784",
                400: "#66bb6a",
                500: "#4caf50",
                600: "#43a047",
                700: "#388e3c",
                800: "#2e7d32",
                900: "#1b5e20",
            },
            lightGreen: {
                100: "#dcedc8",
                200: "#c5e1a5",
                300: "#aed581",
                400: "#9ccc65",
                500: "#8bc34a",
                600: "#7cb342",
                700: "#689f38",
                800: "#558b2f",
                900: "#33691e",
            },
            lime: {
                100: "#f0f4c3",
                200: "#e6ee9c",
                300: "#dce775",
                400: "#d4e157",
                500: "#cddc39",
                600: "#c0ca33",
                700: "#afb42b",
                800: "#9e9d24",
                900: "#827717",
            },
            yellow: {
                100: "#fff9c4",
                200: "#fff59d",
                300: "#fff176",
                400: "#ffee58",
                500: "#ffeb3b",
                600: "#fdd835",
                700: "#fbc02d",
                800: "#f9a825",
                900: "#f57f17",
            },
            amber: {
                100: "#ffecb3",
                200: "#ffe082",
                300: "#ffd54f",
                400: "#ffca28",
                500: "#ffc107",
                600: "#ffb300",
                700: "#ffa000",
                800: "#ff8f00",
                900: "#ff6f00",
            },
            orange: {
                100: "#ffe0b2",
                200: "#ffcc80",
                300: "#ffb74d",
                400: "#ffa726",
                500: "#ff9800",
                600: "#fb8c00",
                700: "#f57c00",
                800: "#ef6c00",
                900: "#e65100",
            },
            deepOrange: {
                100: "#ffccbc",
                200: "#ffab91",
                300: "#ff8a65",
                400: "#ff7043",
                500: "#ff5722",
                600: "#f4511e",
                700: "#e64a19",
                800: "#d84315",
                900: "#bf360c",
            },
            // brown: {
            //   100: "#d7ccc8",
            //   200: "#bcaaa4",
            //   300: "#a1887f",
            //   400: "#8d6e63",
            //   500: "#795548",
            //   600: "#6d4c41",
            //   700: "#5d4037",
            //   800: "#4e342e",
            //   900: "#3e2723",
            // },
            //   grey: {
            //     100: "#f5f5f5",
            //     200: "#eeeeee",
            //     300: "#e0e0e0",
            //     400: "#bdbdbd",
            //     500: "#9e9e9e",
            //     600: "#757575",
            //     700: "#616161",
            //     800: "#424242",
            //     900: "#212121",
            //   },
            //   blueGrey: {
            //     100: "#cfd8dc",
            //     200: "#b0bec5",
            //     300: "#90a4ae",
            //     400: "#78909c",
            //     500: "#607d8b",
            //     600: "#546e7a",
            //     700: "#455a64",
            //     800: "#37474f",
            //     900: "#263238",
            //   },
        };
        DataVisualizationHelper.DIVERGENT_PALETTE = {
            orange: DataVisualizationHelper.MUI_PALETTE.orange[500],
            lightBlue: DataVisualizationHelper.MUI_PALETTE.lightBlue[500],
            yellow: DataVisualizationHelper.MUI_PALETTE.yellow[500],
            indigo: DataVisualizationHelper.MUI_PALETTE.indigo[500],
            lightGreen: DataVisualizationHelper.MUI_PALETTE.lightGreen[500],
            purple: DataVisualizationHelper.MUI_PALETTE.purple[500],
            teal: DataVisualizationHelper.MUI_PALETTE.teal[500],
            red: DataVisualizationHelper.MUI_PALETTE.red[500],
            amber: DataVisualizationHelper.MUI_PALETTE.amber[500],
            blue: DataVisualizationHelper.MUI_PALETTE.blue[500],
            lime: DataVisualizationHelper.MUI_PALETTE.lime[500],
            deepPurple: DataVisualizationHelper.MUI_PALETTE.deepPurple[500],
            green: DataVisualizationHelper.MUI_PALETTE.green[500],
            pink: DataVisualizationHelper.MUI_PALETTE.pink[500],
            cyan: DataVisualizationHelper.MUI_PALETTE.cyan[500],
            deepOrange: DataVisualizationHelper.MUI_PALETTE.deepOrange[500],
        };
        DataVisualizationHelper.CONTINUOUS_PALETTE = {
            100: {
                orange: DataVisualizationHelper.MUI_PALETTE.orange[100],
                deepOrange: DataVisualizationHelper.MUI_PALETTE.deepOrange[100],
                red: DataVisualizationHelper.MUI_PALETTE.red[100],
                pink: DataVisualizationHelper.MUI_PALETTE.pink[100],
                purple: DataVisualizationHelper.MUI_PALETTE.purple[100],
                deepPurple: DataVisualizationHelper.MUI_PALETTE.deepPurple[100],
                indigo: DataVisualizationHelper.MUI_PALETTE.indigo[100],
                blue: DataVisualizationHelper.MUI_PALETTE.blue[100],
                lightBlue: DataVisualizationHelper.MUI_PALETTE.lightBlue[100],
                cyan: DataVisualizationHelper.MUI_PALETTE.cyan[100],
                teal: DataVisualizationHelper.MUI_PALETTE.teal[100],
                green: DataVisualizationHelper.MUI_PALETTE.green[100],
                lightGreen: DataVisualizationHelper.MUI_PALETTE.lightGreen[100],
                lime: DataVisualizationHelper.MUI_PALETTE.lime[100],
                yellow: DataVisualizationHelper.MUI_PALETTE.yellow[100],
                amber: DataVisualizationHelper.MUI_PALETTE.amber[100],
            },
            200: {
                orange: DataVisualizationHelper.MUI_PALETTE.orange[200],
                deepOrange: DataVisualizationHelper.MUI_PALETTE.deepOrange[200],
                red: DataVisualizationHelper.MUI_PALETTE.red[200],
                pink: DataVisualizationHelper.MUI_PALETTE.pink[200],
                purple: DataVisualizationHelper.MUI_PALETTE.purple[200],
                deepPurple: DataVisualizationHelper.MUI_PALETTE.deepPurple[200],
                indigo: DataVisualizationHelper.MUI_PALETTE.indigo[200],
                blue: DataVisualizationHelper.MUI_PALETTE.blue[200],
                lightBlue: DataVisualizationHelper.MUI_PALETTE.lightBlue[200],
                cyan: DataVisualizationHelper.MUI_PALETTE.cyan[200],
                teal: DataVisualizationHelper.MUI_PALETTE.teal[200],
                green: DataVisualizationHelper.MUI_PALETTE.green[200],
                lightGreen: DataVisualizationHelper.MUI_PALETTE.lightGreen[200],
                lime: DataVisualizationHelper.MUI_PALETTE.lime[200],
                yellow: DataVisualizationHelper.MUI_PALETTE.yellow[200],
                amber: DataVisualizationHelper.MUI_PALETTE.amber[200],
            },
            300: {
                orange: DataVisualizationHelper.MUI_PALETTE.orange[300],
                deepOrange: DataVisualizationHelper.MUI_PALETTE.deepOrange[300],
                red: DataVisualizationHelper.MUI_PALETTE.red[300],
                pink: DataVisualizationHelper.MUI_PALETTE.pink[300],
                purple: DataVisualizationHelper.MUI_PALETTE.purple[300],
                deepPurple: DataVisualizationHelper.MUI_PALETTE.deepPurple[300],
                indigo: DataVisualizationHelper.MUI_PALETTE.indigo[300],
                blue: DataVisualizationHelper.MUI_PALETTE.blue[300],
                lightBlue: DataVisualizationHelper.MUI_PALETTE.lightBlue[300],
                cyan: DataVisualizationHelper.MUI_PALETTE.cyan[300],
                teal: DataVisualizationHelper.MUI_PALETTE.teal[300],
                green: DataVisualizationHelper.MUI_PALETTE.green[300],
                lightGreen: DataVisualizationHelper.MUI_PALETTE.lightGreen[300],
                lime: DataVisualizationHelper.MUI_PALETTE.lime[300],
                yellow: DataVisualizationHelper.MUI_PALETTE.yellow[300],
                amber: DataVisualizationHelper.MUI_PALETTE.amber[300],
            },
            400: {
                orange: DataVisualizationHelper.MUI_PALETTE.orange[400],
                deepOrange: DataVisualizationHelper.MUI_PALETTE.deepOrange[400],
                red: DataVisualizationHelper.MUI_PALETTE.red[400],
                pink: DataVisualizationHelper.MUI_PALETTE.pink[400],
                purple: DataVisualizationHelper.MUI_PALETTE.purple[400],
                deepPurple: DataVisualizationHelper.MUI_PALETTE.deepPurple[400],
                indigo: DataVisualizationHelper.MUI_PALETTE.indigo[400],
                blue: DataVisualizationHelper.MUI_PALETTE.blue[400],
                lightBlue: DataVisualizationHelper.MUI_PALETTE.lightBlue[400],
                cyan: DataVisualizationHelper.MUI_PALETTE.cyan[400],
                teal: DataVisualizationHelper.MUI_PALETTE.teal[400],
                green: DataVisualizationHelper.MUI_PALETTE.green[400],
                lightGreen: DataVisualizationHelper.MUI_PALETTE.lightGreen[400],
                lime: DataVisualizationHelper.MUI_PALETTE.lime[400],
                yellow: DataVisualizationHelper.MUI_PALETTE.yellow[400],
                amber: DataVisualizationHelper.MUI_PALETTE.amber[400],
            },
            500: {
                orange: DataVisualizationHelper.MUI_PALETTE.orange[500],
                deepOrange: DataVisualizationHelper.MUI_PALETTE.deepOrange[500],
                red: DataVisualizationHelper.MUI_PALETTE.red[500],
                pink: DataVisualizationHelper.MUI_PALETTE.pink[500],
                purple: DataVisualizationHelper.MUI_PALETTE.purple[500],
                deepPurple: DataVisualizationHelper.MUI_PALETTE.deepPurple[500],
                indigo: DataVisualizationHelper.MUI_PALETTE.indigo[500],
                blue: DataVisualizationHelper.MUI_PALETTE.blue[500],
                lightBlue: DataVisualizationHelper.MUI_PALETTE.lightBlue[500],
                cyan: DataVisualizationHelper.MUI_PALETTE.cyan[500],
                teal: DataVisualizationHelper.MUI_PALETTE.teal[500],
                green: DataVisualizationHelper.MUI_PALETTE.green[500],
                lightGreen: DataVisualizationHelper.MUI_PALETTE.lightGreen[500],
                lime: DataVisualizationHelper.MUI_PALETTE.lime[500],
                yellow: DataVisualizationHelper.MUI_PALETTE.yellow[500],
                amber: DataVisualizationHelper.MUI_PALETTE.amber[500],
            },
            600: {
                orange: DataVisualizationHelper.MUI_PALETTE.orange[600],
                deepOrange: DataVisualizationHelper.MUI_PALETTE.deepOrange[600],
                red: DataVisualizationHelper.MUI_PALETTE.red[600],
                pink: DataVisualizationHelper.MUI_PALETTE.pink[600],
                purple: DataVisualizationHelper.MUI_PALETTE.purple[600],
                deepPurple: DataVisualizationHelper.MUI_PALETTE.deepPurple[600],
                indigo: DataVisualizationHelper.MUI_PALETTE.indigo[600],
                blue: DataVisualizationHelper.MUI_PALETTE.blue[600],
                lightBlue: DataVisualizationHelper.MUI_PALETTE.lightBlue[600],
                cyan: DataVisualizationHelper.MUI_PALETTE.cyan[600],
                teal: DataVisualizationHelper.MUI_PALETTE.teal[600],
                green: DataVisualizationHelper.MUI_PALETTE.green[600],
                lightGreen: DataVisualizationHelper.MUI_PALETTE.lightGreen[600],
                lime: DataVisualizationHelper.MUI_PALETTE.lime[600],
                yellow: DataVisualizationHelper.MUI_PALETTE.yellow[600],
                amber: DataVisualizationHelper.MUI_PALETTE.amber[600],
            },
            700: {
                orange: DataVisualizationHelper.MUI_PALETTE.orange[700],
                deepOrange: DataVisualizationHelper.MUI_PALETTE.deepOrange[700],
                red: DataVisualizationHelper.MUI_PALETTE.red[700],
                pink: DataVisualizationHelper.MUI_PALETTE.pink[700],
                purple: DataVisualizationHelper.MUI_PALETTE.purple[700],
                deepPurple: DataVisualizationHelper.MUI_PALETTE.deepPurple[700],
                indigo: DataVisualizationHelper.MUI_PALETTE.indigo[700],
                blue: DataVisualizationHelper.MUI_PALETTE.blue[700],
                lightBlue: DataVisualizationHelper.MUI_PALETTE.lightBlue[700],
                cyan: DataVisualizationHelper.MUI_PALETTE.cyan[700],
                teal: DataVisualizationHelper.MUI_PALETTE.teal[700],
                green: DataVisualizationHelper.MUI_PALETTE.green[700],
                lightGreen: DataVisualizationHelper.MUI_PALETTE.lightGreen[700],
                lime: DataVisualizationHelper.MUI_PALETTE.lime[700],
                yellow: DataVisualizationHelper.MUI_PALETTE.yellow[700],
                amber: DataVisualizationHelper.MUI_PALETTE.amber[700],
            },
            800: {
                orange: DataVisualizationHelper.MUI_PALETTE.orange[800],
                deepOrange: DataVisualizationHelper.MUI_PALETTE.deepOrange[800],
                red: DataVisualizationHelper.MUI_PALETTE.red[800],
                pink: DataVisualizationHelper.MUI_PALETTE.pink[800],
                purple: DataVisualizationHelper.MUI_PALETTE.purple[800],
                deepPurple: DataVisualizationHelper.MUI_PALETTE.deepPurple[800],
                indigo: DataVisualizationHelper.MUI_PALETTE.indigo[800],
                blue: DataVisualizationHelper.MUI_PALETTE.blue[800],
                lightBlue: DataVisualizationHelper.MUI_PALETTE.lightBlue[800],
                cyan: DataVisualizationHelper.MUI_PALETTE.cyan[800],
                teal: DataVisualizationHelper.MUI_PALETTE.teal[800],
                green: DataVisualizationHelper.MUI_PALETTE.green[800],
                lightGreen: DataVisualizationHelper.MUI_PALETTE.lightGreen[800],
                lime: DataVisualizationHelper.MUI_PALETTE.lime[800],
                yellow: DataVisualizationHelper.MUI_PALETTE.yellow[800],
                amber: DataVisualizationHelper.MUI_PALETTE.amber[800],
            },
            900: {
                orange: DataVisualizationHelper.MUI_PALETTE.orange[900],
                deepOrange: DataVisualizationHelper.MUI_PALETTE.deepOrange[900],
                red: DataVisualizationHelper.MUI_PALETTE.red[900],
                pink: DataVisualizationHelper.MUI_PALETTE.pink[900],
                purple: DataVisualizationHelper.MUI_PALETTE.purple[900],
                deepPurple: DataVisualizationHelper.MUI_PALETTE.deepPurple[900],
                indigo: DataVisualizationHelper.MUI_PALETTE.indigo[900],
                blue: DataVisualizationHelper.MUI_PALETTE.blue[900],
                lightBlue: DataVisualizationHelper.MUI_PALETTE.lightBlue[900],
                cyan: DataVisualizationHelper.MUI_PALETTE.cyan[900],
                teal: DataVisualizationHelper.MUI_PALETTE.teal[900],
                green: DataVisualizationHelper.MUI_PALETTE.green[900],
                lightGreen: DataVisualizationHelper.MUI_PALETTE.lightGreen[900],
                lime: DataVisualizationHelper.MUI_PALETTE.lime[900],
                yellow: DataVisualizationHelper.MUI_PALETTE.yellow[900],
                amber: DataVisualizationHelper.MUI_PALETTE.amber[900],
            },
        };
        DataVisualizationHelper.BRIGHTNESS_LEVELS = [
            700, 200, 500, 300, 400, 100, 900, 600, 800,
        ];
        Helper.DataVisualizationHelper = DataVisualizationHelper;
        class PlayerFeaturePopupHelper {
            static get instance() {
                if (!PlayerFeaturePopupHelper._instance)
                    PlayerFeaturePopupHelper._instance = new PlayerFeaturePopupHelper();
                return PlayerFeaturePopupHelper._instance;
            }
            constructor() {
                this.current = null;
            }
            static show(props) {
                const { instance } = this;
                const { featureId, popupUrl, markAsSeenUrl, delayMilliSeconds } = props;
                if (instance.current == null) {
                    instance.current = featureId;
                    if (delayMilliSeconds) {
                        CS.Lag(`player-feature-popup-helper-show-${featureId}`, delayMilliSeconds, () => {
                            PlayerFeaturePopupHelper._show(popupUrl, markAsSeenUrl);
                        });
                    }
                    else {
                        PlayerFeaturePopupHelper._show(popupUrl, markAsSeenUrl);
                    }
                }
            }
            static _show(popupUrl, markAsSeenUrl) {
                const { instance } = this;
                instance.current = null;
                CS.Controls.Popup.ShowAjaxModal(popupUrl, {}, ({ popup }) => {
                    if (!Helper.isNullOrWhiteSpace(markAsSeenUrl)) {
                        CS.Ajax.Post(markAsSeenUrl, {});
                    }
                }, ({ popup }) => { }, true, true);
            }
        }
        Helper.PlayerFeaturePopupHelper = PlayerFeaturePopupHelper;
        Helper.isNullOrWhiteSpace = (str) => {
            if (typeof str === "undefined" || str == null || typeof str != "string")
                return true;
            return str.trim() === "";
        };
        Helper.IntMinValue = -2147483648;
        Helper.IntMaxValue = 2147483647;
        let FitWidthBasedOnReference;
        (function (FitWidthBasedOnReference) {
            FitWidthBasedOnReference[FitWidthBasedOnReference["None"] = 0] = "None";
            FitWidthBasedOnReference[FitWidthBasedOnReference["AlwaysFit"] = 1] = "AlwaysFit";
            FitWidthBasedOnReference[FitWidthBasedOnReference["FitOnlyIfReferenceIsSmaller"] = 2] = "FitOnlyIfReferenceIsSmaller";
            FitWidthBasedOnReference[FitWidthBasedOnReference["FitOnlyIfReferenceIsBigger"] = 3] = "FitOnlyIfReferenceIsBigger";
        })(FitWidthBasedOnReference = Helper.FitWidthBasedOnReference || (Helper.FitWidthBasedOnReference = {}));
        function GetQueryStringVars(url) {
            let map = new Map();
            if (!url || url.indexOf("?") == -1) {
                return map;
            }
            var hashes = url.slice(url.indexOf("?") + 1).split("&");
            for (var i = 0; i < hashes.length; i++) {
                let hash = hashes[i].split("=");
                map.set(hash[0].toLowerCase(), hash[1]);
            }
            return map;
        }
        Helper.GetQueryStringVars = GetQueryStringVars;
        function ReplaceQueryString(url, queryStrings) {
            if (!url) {
                return url;
            }
            let index = url.indexOf("?");
            let newUrl = url;
            if (index != -1) {
                newUrl = url.substr(0, index);
            }
            let a = new Array();
            queryStrings.forEach((v, k) => a.push(k + "=" + v));
            let q = a.join("&");
            if (q) {
                return newUrl + "?" + q;
            }
            return newUrl;
        }
        Helper.ReplaceQueryString = ReplaceQueryString;
        const layoutHelperLeft = "LayoutHelperLeft";
        const layoutHelperRight = "LayoutHelperRight";
        const layoutHelperTop = "LayoutHelperTop";
        const layoutHelperBottom = "LayoutHelperBottom";
        let scrollThickness;
        function PositionElementBasedOnOther($reference, $toPosition, fitWidthBasedOnReference, positionLeftByDefault, forceOpenBelow) {
            let keepScroll = $toPosition.scrollTop();
            let left = "auto";
            let right = "auto";
            let top = "auto";
            let bottom = "auto";
            let toPosCssHeight = "auto";
            let width = "auto";
            let toPosRenderedWidth;
            let toPosRenderedHeight;
            let winScroll = GetWindowScroll();
            let screenWidth = CS.DOM.$win.width();
            let screenHeight = CS.DOM.$win.height();
            let midScreenV = screenHeight / 2;
            if ($reference.css("position") === "fixed") {
                screenLeft = winScroll.X;
                screenTop = winScroll.Y;
            }
            if (positionLeftByDefault) {
                $toPosition.css({
                    top: top,
                    height: toPosCssHeight,
                    position: "fixed",
                });
            }
            else {
                $toPosition.css({
                    left: left,
                    right: right,
                    top: top,
                    height: toPosCssHeight,
                    position: "fixed",
                });
            }
            toPosRenderedWidth = $toPosition.outerWidth(true);
            toPosRenderedHeight = $toPosition.outerHeight(true);
            let refOffset = $reference.offset();
            let refLeft = refOffset.left - winScroll.X;
            let refTop = refOffset.top - winScroll.Y;
            var refHeight = $reference[0].offsetHeight;
            let refBottom = refTop + refHeight;
            left = refLeft;
            top = refTop + refHeight;
            let overflow = false;
            if (refBottom + toPosRenderedHeight > screenHeight) {
                if (forceOpenBelow || refTop <= midScreenV) {
                    //Cetait refBottom <= midScreenV mais selon certain cas, l'affichage était pas terrible, donc, cest mieux si cest le top qui depasse la moitié
                    bottom = 0;
                    overflow = true;
                    toPosCssHeight = "auto";
                }
                else {
                    if (refTop - toPosRenderedHeight < 0) {
                        top = 0;
                        overflow = true;
                    }
                    else {
                        top = "auto";
                    }
                    bottom = screenHeight - refTop;
                }
            }
            let fitWidth = false;
            if (fitWidthBasedOnReference == FitWidthBasedOnReference.AlwaysFit) {
                fitWidth = true;
            }
            if (fitWidthBasedOnReference ==
                FitWidthBasedOnReference.FitOnlyIfReferenceIsBigger &&
                toPosRenderedWidth <= $reference[0].offsetWidth) {
                fitWidth = true;
            }
            if (fitWidthBasedOnReference ==
                FitWidthBasedOnReference.FitOnlyIfReferenceIsSmaller &&
                toPosRenderedWidth >= $reference[0].offsetWidth) {
                fitWidth = true;
            }
            if (fitWidth) {
                left = refLeft;
                width = $reference[0].offsetWidth;
            }
            else if (left + toPosRenderedWidth > screenWidth) {
                left = "auto";
                right = 0;
            }
            if (positionLeftByDefault) {
                $toPosition.css({
                    top: top,
                    bottom: bottom,
                    height: toPosCssHeight,
                    width: width,
                });
            }
            else {
                $toPosition.css({
                    left: left,
                    right: right,
                    top: top,
                    bottom: bottom,
                    height: toPosCssHeight,
                    width: width,
                });
            }
            if (overflow) {
                $toPosition.addClass("overflow");
            }
            else {
                $toPosition.removeClass("overflow");
            }
            if (keepScroll > 0) {
                $toPosition.scrollTop(keepScroll);
            }
        }
        Helper.PositionElementBasedOnOther = PositionElementBasedOnOther;
        /**
         * Returns true if all values in array are numbers.
         */
        function areNumeric(values) {
            let result = true;
            values.forEach((value, index) => {
                if (isNaN(value))
                    result = false;
            });
            return result;
        }
        Helper.areNumeric = areNumeric;
        function GetScrollThickness() {
            if (scrollThickness != null) {
                return scrollThickness;
            }
            let outside = document.createElement("div");
            let inside = document.createElement("div");
            outside.style.width = inside.style.width = "100%";
            outside.style.overflow = "scroll";
            document.body.appendChild(outside).appendChild(inside);
            scrollThickness = outside.offsetWidth - inside.offsetWidth;
            outside.parentNode.removeChild(outside);
            return scrollThickness;
        }
        Helper.GetScrollThickness = GetScrollThickness;
        function MeasureStringHeight(context) {
            let testElement = $("<span>XWE</span>");
            context.prepend(testElement);
            let height = testElement.css("line-height");
            testElement.remove();
            return parseFloat(height.replace("px", ""));
        }
        Helper.MeasureStringHeight = MeasureStringHeight;
        ///La valeur doit etre soit exemple 10em et non, simplement un nombre
        function ConvertEmToPx(value, relativeTo) {
            var elementTest = $("<div></div>");
            elementTest.css({
                position: "relative",
                height: value,
                padding: 0,
                margin: 0,
                border: "1px solid red",
            });
            relativeTo.append(elementTest);
            let height = elementTest.outerHeight();
            elementTest.remove();
            return height;
        }
        Helper.ConvertEmToPx = ConvertEmToPx;
        function ConvertPxToEm(value, relativeTo) {
            var tempValue = "100em";
            let pxValue = ConvertEmToPx(tempValue, relativeTo);
            return value / (pxValue / 100);
        }
        Helper.ConvertPxToEm = ConvertPxToEm;
        function GetWindowScroll() {
            var scrollX = 0;
            var scrollY = 0;
            if (window.scrollX != undefined) {
                //Patch IOS
                scrollX = window.scrollX;
                scrollY = window.scrollY;
            }
            else {
                scrollX = CS.DOM.$win.scrollLeft();
                scrollY = CS.DOM.$win.scrollTop();
            }
            return {
                X: scrollX,
                Y: scrollY,
            };
        }
        Helper.GetWindowScroll = GetWindowScroll;
        let MomentJs;
        (function (MomentJs) {
            function ConvertMomentToJsDate(momentDate, ignoreTimeZone = true) {
                if (ignoreTimeZone)
                    return new Date(momentDate.format("YYYY-MM-DD HH:mm"));
                return momentDate.toDate();
            }
            MomentJs.ConvertMomentToJsDate = ConvertMomentToJsDate;
            /**
             * this return a cloned version of the manipulated moment
             * @param date
             * the date to manipulate
             * @param timeSpan
             * specify the TimeSpan to apply the operation
             * @param operation
             * operation : 'add' or 'substract'
             */
            function manipulateDate(date, timeSpan, operation) {
                let result = date.clone();
                let man = result[operation]; //This will be moment.substract() or moment.add();
                for (var key in timeSpan) {
                    if (timeSpan[key])
                        man.call(result, timeSpan[key], key); //if a property called "days" is 7 and opperation is 'add' this will do: result.add(7, 'days')
                }
                return result;
            }
            MomentJs.manipulateDate = manipulateDate;
        })(MomentJs = Helper.MomentJs || (Helper.MomentJs = {}));
        class StoredVar {
            constructor(storageType, storageKey, initialValue = null) {
                this.storageType = storageType;
                this.storageKey = storageKey;
                this.initialValue = initialValue;
                this.raiseChange = {};
                this.Changed = new CS.Events.Event(storageKey + "_Changed", this.raiseChange);
                this.Reload();
                if (this.item == null && initialValue)
                    this.item = initialValue;
            }
            get Item() {
                return this.item;
            }
            set Item(value) {
                this.item = value;
                this.Save();
                this.raiseChange.raiseEvent(this.item, this);
            }
            /**The valus is loaded when this class was instanciated. You can reload the value in case you change it on an other instance. */
            Reload() {
                var value = this.storage.getItem(this.storageKey);
                if (value) {
                    this.item = JSON.parse(value);
                }
            }
            /** Re-save the value. The valus is saved when you set Item = value. Re-Save it you changed value inside the object. */
            Save() {
                this.storage.setItem(this.storageKey, JSON.stringify(this.item));
            }
            get storage() {
                if (this.storageType != "window" && window[this.storageType])
                    return window[this.storageType];
                let create = () => {
                    window["StoredVar_STORE"] = {
                        clear: () => {
                            create();
                        },
                        getItem: (key) => {
                            return window["StoredVar_STORE"][key];
                        },
                        removeItem: (key) => {
                            delete window["StoredVar_STORE"][key];
                        },
                        setItem: (key, value) => {
                            window["StoredVar_STORE"][key] = value;
                        },
                    };
                };
                if (!window["StoredVar_STORE"])
                    create();
                return window["StoredVar_STORE"];
            }
        }
        Helper.StoredVar = StoredVar;
        class CSIntersectionObserver {
            get $observedElement() {
                return this._$observedElement;
            }
            get height() {
                return this._height;
            }
            get position() {
                return this._position;
            }
            get topMargin() {
                return this._topMargin;
            }
            get bottomMargin() {
                return this._bottomMargin;
            }
            get isHidden() {
                return this.isHiddenTop || this.isHiddenBottom;
            }
            get isHiddenTop() {
                return this.pixelsUntilHiddenTop <= 0;
            }
            get isHiddenBottom() {
                return this.pixelsUntilHiddenBottom <= 0;
            }
            get isPartiallyHidden() {
                return this.isPartiallyHiddenTop || this.isPartiallyHiddenBottom;
            }
            get pixelsUntilIntersectionTop() {
                return this.position.top - this.topMargin;
            }
            get pixelsUntilIntersectionBottom() {
                return (document.documentElement.clientHeight -
                    this.position.bottom -
                    this.bottomMargin);
            }
            get pixelsUntilHiddenTop() {
                return this.pixelsUntilIntersectionTop + this.height;
            }
            get pixelsUntilHiddenBottom() {
                return this.pixelsUntilIntersectionBottom + this.height;
            }
            get isPartiallyHiddenTop() {
                return this.pixelsUntilHiddenTop < this.height;
            }
            get isPartiallyHiddenBottom() {
                return (this.pixelsUntilHiddenBottom < this.height &&
                    this.position.top > this.topMargin);
            }
            constructor($observedElement, topHeight, bottomHeight) {
                this._$observedElement = $observedElement;
                this.setTopBottomMarginValues(topHeight, bottomHeight);
                this.setObservedElementValues();
            }
            observeIntersections(uniqueId, onIsVisible, onIsPartiallyHidden, onIsHidden) {
                this._uniqueId = uniqueId;
                this._observeIntersectionsEvents = `scroll.${this._uniqueId}-intersection-observer-all`;
                this._observeIntersectionsCallback = () => {
                    this.setObservedElementValues();
                    const { position, height } = this;
                    const pixelsUntilIntersectionTop = position.top - this.topMargin;
                    const pixelsUntilHiddenTop = pixelsUntilIntersectionTop + height;
                    const isPartiallyHiddenTop = pixelsUntilHiddenTop < height && pixelsUntilHiddenTop > 0;
                    const isHiddenTop = pixelsUntilHiddenTop <= 0;
                    const hiddenRatioTop = (height - pixelsUntilHiddenTop) / height;
                    const invertedHiddenRatioTop = 1 - hiddenRatioTop;
                    const pixelsUntilIntersectionBottom = document.documentElement.clientHeight -
                        position.bottom -
                        this.bottomMargin;
                    const pixelsUntilHiddenBottom = pixelsUntilIntersectionBottom + height;
                    const isPartiallyHiddenBottom = pixelsUntilHiddenBottom < height && pixelsUntilHiddenBottom > 0;
                    const isHiddenBottom = pixelsUntilHiddenBottom <= 0;
                    const hiddenRatioBottom = (height - pixelsUntilHiddenBottom) / height;
                    const invertedHiddenRatioBottom = 1 - hiddenRatioBottom;
                    if (isHiddenTop || isHiddenBottom) {
                        if (onIsHidden != null) {
                            onIsHidden.call(this);
                        }
                    }
                    else if (isPartiallyHiddenTop || isPartiallyHiddenBottom) {
                        if (onIsPartiallyHidden != null) {
                            if (isPartiallyHiddenTop)
                                onIsPartiallyHidden.call(this, hiddenRatioTop, invertedHiddenRatioTop);
                            else if (isPartiallyHiddenBottom)
                                onIsPartiallyHidden.call(this, hiddenRatioBottom, invertedHiddenRatioBottom);
                        }
                    }
                    else {
                        if (onIsVisible != null) {
                            onIsVisible.call(this);
                        }
                    }
                };
                this._observeIntersectionsCallback();
                CS.DOM.$win.offon(this._observeIntersectionsEvents, this._observeIntersectionsCallback);
            }
            observeTopIntersections(uniqueId, onIsVisible, onIsPartiallyHidden, onIsHidden) {
                this._uniqueId = uniqueId;
                this._observeTopIntersectionsEvents = `scroll.${this._uniqueId}-intersection-observer`;
                this._observeTopIntersectionsCallback = () => {
                    this.setObservedElementValues();
                    const { position, height } = this;
                    const pixelsUntilIntersection = position.top - this.topMargin, pixelsUntilHidden = pixelsUntilIntersection + height;
                    const isPartiallyHidden = pixelsUntilHidden < height && pixelsUntilHidden > 0, isHidden = pixelsUntilHidden <= 0;
                    const hiddenRatio = (height - pixelsUntilHidden) / height, invertedHiddenRatio = 1 - hiddenRatio;
                    if (isHidden) {
                        if (onIsHidden != null) {
                            onIsHidden.call(this);
                        }
                    }
                    else if (isPartiallyHidden) {
                        if (onIsPartiallyHidden != null) {
                            onIsPartiallyHidden.call(this, hiddenRatio, invertedHiddenRatio);
                        }
                    }
                    else {
                        if (onIsVisible != null) {
                            onIsVisible.call(this);
                        }
                    }
                };
                CS.DOM.$win.offon(this._observeTopIntersectionsEvents, this._observeTopIntersectionsCallback);
            }
            stopObservingTopIntersections() {
                if (this._observeTopIntersectionsEvents != null &&
                    this._observeTopIntersectionsCallback != null) {
                    CS.DOM.$win.off(this._observeTopIntersectionsEvents, this._observeTopIntersectionsCallback);
                }
            }
            stopObserving() {
                this.stopObservingTopIntersections();
            }
            elementIsFullyVisible() {
                this.setObservedElementValues();
                return !this.isPartiallyHiddenTop && !this.isPartiallyHiddenBottom;
            }
            scrollUntilVisible(topMargin, callback) {
                const position = this.$observedElement[0].getBoundingClientRect();
                const scrollTop = position.top - topMargin - this.topMargin;
                // TODO : Déterminer si on doit scroll vers le haut ou le bas
                $([document.documentElement, document.body]).animate({
                    scrollTop: scrollTop,
                }, 500, () => {
                    if (callback != null)
                        callback.call(this);
                });
            }
            setTopBottomMarginValues(topHeight, bottomHeight) {
                if (topHeight != null)
                    this._topMargin = topHeight;
                else if (CS.DOM.$topBar.length > 0)
                    this._topMargin = CS.DOM.$topBar.last().outerHeight();
                else
                    this._topMargin = 0;
                if (CS.DOM.$subTop.length > 0)
                    this._topMargin += CS.DOM.$subTop.last().outerHeight();
                if (bottomHeight != null)
                    this._bottomMargin = bottomHeight;
                else if (CS.DOM.$sectionBottom.length > 0)
                    this._bottomMargin = CS.DOM.$sectionBottom.last().outerHeight();
                else
                    this._bottomMargin = 0;
            }
            setObservedElementValues() {
                this._height = this.$observedElement.outerHeight();
                this._position = this.$observedElement[0].getBoundingClientRect();
            }
        }
        Helper.CSIntersectionObserver = CSIntersectionObserver;
        class ConfettiHelper {
            get maxParticlesCount() {
                return ConfettiHelper.instance._maxParticlesCount;
            }
            get particleSpeed() {
                return ConfettiHelper.instance._particleSpeed;
            }
            get streamingConfetti() {
                return ConfettiHelper.instance._streamingConfetti;
            }
            get animationTimer() {
                return ConfettiHelper.instance._animationTimer;
            }
            get particles() {
                return ConfettiHelper.instance._particles;
            }
            get waveAngle() {
                return ConfettiHelper.instance._waveAngle;
            }
            get colors() {
                return ConfettiHelper.instance._colors;
            }
            get $container() {
                return ConfettiHelper.instance._$container;
            }
            static get instance() {
                if (!ConfettiHelper._instance)
                    ConfettiHelper._instance = new ConfettiHelper();
                return ConfettiHelper._instance;
            }
            constructor() {
                this._maxParticlesCount = 50;
                this._particleSpeed = 0.25;
                this._streamingConfetti = false;
                this._animationTimer = null;
                this._particles = [];
                this._waveAngle = 0;
                this._colors = [
                    "DodgerBlue",
                    "OliveDrab",
                    "Gold",
                    "Pink",
                    "SlateBlue",
                    "LightBlue",
                    "Violet",
                    "PaleGreen",
                    "SteelBlue",
                    "SandyBrown",
                    "Chocolate",
                    "Crimson",
                ];
            }
            /**Starts the confetti animation. */
            static start($confettiContainer) {
                const { instance } = ConfettiHelper;
                if (!$confettiContainer.is(instance.$container)) {
                    instance._$container = $confettiContainer;
                    ConfettiHelper.remove();
                }
                const { particles, maxParticlesCount, animationTimer, $container } = instance;
                let context2D;
                if ($container != null && $container.length) {
                    let width = $container.innerWidth();
                    let height = $container.innerHeight();
                    let canvas;
                    let $canvas = $container.find("#cs-confetti-canvas");
                    if ($canvas.length) {
                        canvas = $canvas[0];
                    }
                    else {
                        canvas = document.createElement("canvas");
                        canvas.setAttribute("id", "cs-confetti-canvas");
                        canvas.setAttribute("style", "display:block;z-index:999999;pointer-events:none");
                        $container.append(canvas);
                        canvas.width = $container.innerWidth();
                        canvas.height = $container.innerHeight();
                        window.addEventListener("resize", function () {
                            canvas.width = $container.innerWidth();
                            canvas.height = $container.innerHeight();
                        }, true);
                    }
                    context2D = canvas.getContext("2d");
                    console.log(context2D);
                    while (particles.length < maxParticlesCount) {
                        particles.push(ConfettiHelper.resetParticle({}, width, height));
                    }
                    instance._streamingConfetti = true;
                    if (animationTimer === null) {
                        (function runAnimation() {
                            context2D.clearRect(0, 0, $container.innerWidth(), $container.innerHeight());
                            if (particles.length === 0) {
                                instance._animationTimer = null;
                            }
                            else {
                                ConfettiHelper.updateParticles();
                                ConfettiHelper.drawParticles(context2D);
                                instance._animationTimer = requestAnimationFrame(runAnimation);
                            }
                        })();
                    }
                }
            }
            /**Stops the confetti animation, but doesn't remove current particles. */
            static stop() {
                const { instance } = ConfettiHelper;
                instance._streamingConfetti = false;
            }
            /**Starts or stops the confetti animation depending on wether it's already running. */
            static toggle($confettiContainer) {
                const { instance } = ConfettiHelper;
                if (!$confettiContainer.is(instance.$container)) {
                    instance._$container = $confettiContainer;
                    ConfettiHelper.remove();
                }
                const { $container } = instance;
                if (instance.streamingConfetti)
                    ConfettiHelper.stop();
                else
                    ConfettiHelper.start($container);
            }
            /**Stops the confetti animation and remove all particles immediately. */
            static remove() {
                const { instance } = ConfettiHelper;
                ConfettiHelper.stop();
                instance._particles = [];
            }
            static resetParticle(particle, width, height) {
                const { instance } = ConfettiHelper;
                const { colors } = instance;
                particle.color = colors[(Math.random() * colors.length) | 0];
                particle.x = Math.random() * width;
                particle.y = Math.random() * height - height;
                particle.diameter = Math.random() * 10 + 5;
                particle.tilt = Math.random() * 10 - 10;
                particle.tiltAngleIncrement = Math.random() * 0.07 + 0.05;
                particle.tiltAngle = 0;
                return particle;
            }
            static drawParticles(context) {
                const { instance } = ConfettiHelper;
                const { particles } = instance;
                let particle;
                let x;
                for (let i = 0; i < particles.length; i++) {
                    particle = particles[i];
                    context.beginPath();
                    context.lineWidth = particle.diameter;
                    context.strokeStyle = particle.color;
                    x = particle.x + particle.tilt;
                    context.moveTo(x + particle.diameter / 2, particle.y);
                    context.lineTo(x, particle.y + particle.tilt + particle.diameter / 2);
                    context.stroke();
                }
            }
            static updateParticles() {
                const { instance } = ConfettiHelper;
                instance._waveAngle += 0.01;
                const { waveAngle, particles, $container, particleSpeed, streamingConfetti, maxParticlesCount, } = instance;
                let width = $container.innerWidth();
                let height = $container.innerHeight();
                let particle;
                for (let i = 0; i < particles.length; i++) {
                    particle = particles[i];
                    if (!streamingConfetti && particle.y < -15)
                        particle.y = height + 100;
                    else {
                        particle.tiltAngle += particle.tiltAngleIncrement;
                        particle.x += Math.sin(waveAngle);
                        particle.y +=
                            (Math.cos(waveAngle) + particle.diameter + particleSpeed) * 0.5;
                        particle.tilt = Math.sin(particle.tiltAngle) * 15;
                    }
                    if (particle.x > width + 20 ||
                        particle.x < -20 ||
                        particle.y > height) {
                        if (streamingConfetti && particles.length <= maxParticlesCount)
                            ConfettiHelper.resetParticle(particle, width, height);
                        else {
                            particles.splice(i, 1);
                            i--;
                        }
                    }
                }
            }
        }
        Helper.ConfettiHelper = ConfettiHelper;
        function GetHeightOfHiddenElement($element, addClassBeforeComputingHeight, removeClassBeforeComputingHeight) {
            const $original = $element;
            if (!$original.length) {
                return 0;
            }
            const $clone = $original.clone(true);
            $clone
                .css("height", "auto")
                .removeClass("hiddenforced")
                .removeClass("hidden");
            if (addClassBeforeComputingHeight != null) {
                $clone.addClass(addClassBeforeComputingHeight);
            }
            if (removeClassBeforeComputingHeight != null) {
                $clone.removeClass(removeClassBeforeComputingHeight);
            }
            $clone
                .css({
                position: "absolute",
                left: "-10000px",
            })
                .appendTo("body");
            const height = $clone.outerHeight();
            $clone.remove();
            return Math.floor(height);
        }
        Helper.GetHeightOfHiddenElement = GetHeightOfHiddenElement;
        function ShowDownloadNativeAppPopupIfNeeded(callback) {
            var _a;
            if (((_a = CS.CommonData === null || CS.CommonData === void 0 ? void 0 : CS.CommonData.Current) === null || _a === void 0 ? void 0 : _a.DebugConfig) == "DEBUG_MM") {
                return callback.call(this);
            }
            const $nativeAppContainer = $("#download-native-app-container");
            if (!$nativeAppContainer.length)
                return callback.call(this);
            const $nativeApp = $nativeAppContainer.find(".download-native-app");
            if (!$nativeApp.length)
                return callback.call(this);
            const getAppUserDataValueUrl = CS.Url.CSUrl("GetAppUserDataValue");
            if (getAppUserDataValueUrl == null)
                return callback.call(this);
            const insertAppUserDataUrl = CS.Url.CSUrl("InsertAppUserData");
            if (insertAppUserDataUrl == null)
                return callback.call(this);
            const now = new Date();
            const utcNow = new Date(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(), now.getUTCHours(), now.getUTCMinutes(), now.getUTCSeconds());
            const utcNowString = utcNow.toISOString();
            const value = {
                dateSeen: utcNowString,
                userDeviceId: CS.CommonData.Current.UserDeviceId,
            };
            const markPopupAsSeen = () => CS.Ajax.Post(insertAppUserDataUrl, {
                category: "NativeApp",
                key: "popup-seen",
                value: JSON.stringify(value),
            }, (response) => {
                console.log(response);
            });
            const showPopup = () => {
                console.log("showPopup");
                $nativeApp.offon("click.downloadNativeApp", (e) => {
                    const $target = $(e.target);
                    if ($target.closest("#button-download-native-app-close").length ||
                        $target.closest("#button-download-native-app-later").length)
                        return $nativeAppContainer.fadeOut(null, () => $nativeAppContainer.remove());
                });
                CS.Lag("downloadNativeApp", 1000, () => {
                    $nativeAppContainer.fadeIn(500, () => {
                        $nativeApp.slideDown(250, () => {
                            markPopupAsSeen();
                        });
                    });
                });
            };
            if (!CS.CommonData.Current.UserIsLoggedIn) {
                showPopup();
                return callback.call(this);
            }
            CS.Ajax.Get(getAppUserDataValueUrl, {
                category: "NativeApp",
                key: "popup-seen",
            }, (response) => {
                if (response != null) {
                    const { value } = response;
                    if (value == null)
                        return showPopup();
                    try {
                        const parsedValue = JSON.parse(value);
                        if (parsedValue.dateSeen == null)
                            return showPopup();
                        // Si ça fait plus de 5 jours qu'on ne l'a pas montré, on la montre à nouveau.
                        const dateSeen = new Date(parsedValue.dateSeen);
                        const utcDateSeen = new Date(dateSeen.getUTCFullYear(), dateSeen.getUTCMonth(), dateSeen.getUTCDate(), dateSeen.getUTCHours(), dateSeen.getUTCMinutes(), dateSeen.getUTCSeconds());
                        const diff = utcNow.getTime() - utcDateSeen.getTime();
                        if (diff > 1000 * 60 * 60 * 24 * 5) {
                            showPopup();
                        }
                        return callback.call(this);
                    }
                    catch (e) {
                        showPopup();
                        return callback.call(this);
                    }
                }
                return callback.call(this);
            });
        }
        Helper.ShowDownloadNativeAppPopupIfNeeded = ShowDownloadNativeAppPopupIfNeeded;
        /**
         * Lazy rendering of items, while still consuming height.
         */
        class LazyRenderer {
            static get instance() {
                if (!LazyRenderer._instance)
                    LazyRenderer._instance = new LazyRenderer();
                return LazyRenderer._instance;
            }
            constructor() {
                this._observers = {};
            }
            static disconnect(key) {
                const instance = LazyRenderer.instance;
                const item = instance._observers[key];
                if (item) {
                    item.observer.disconnect();
                    delete instance._observers[key];
                }
            }
            static initialize(params) {
                const { key, itemCssClass, hiddenItemCssClass, renderedItemCssClass } = params;
                const instance = LazyRenderer.instance;
                LazyRenderer.disconnect(params.key);
                instance._observers[key] = {
                    observer: new IntersectionObserver((entries, observer) => {
                        entries.forEach((entry) => {
                            const { intersectionRatio: entryIntersectionRatio, target } = entry;
                            const intersectionRatio = Math.round(entryIntersectionRatio * 100) / 100;
                            const $target = $(target);
                            if (intersectionRatio > 0)
                                return LazyRenderer.renderElement($target, hiddenItemCssClass, renderedItemCssClass);
                            return LazyRenderer.hideElement($target, hiddenItemCssClass, renderedItemCssClass);
                        });
                    }, {
                        threshold: [0, 0.25, 0.5, 1],
                        rootMargin: "1000px 0px 1000px 0px",
                    }),
                };
                const observer = instance._observers[key].observer;
                const $allItems = $(`.${itemCssClass}`);
                $allItems.each((index, element) => {
                    observer.observe(element);
                });
            }
            static hideElement($el, hiddenItemCssClass, renderedItemCssClass) {
                if ($el.hasClass(renderedItemCssClass)) {
                    $el.data("lazy-renderer-forced-height", $el.outerHeight());
                    $el.removeClass(renderedItemCssClass);
                    $el.addClass(hiddenItemCssClass);
                    $el.wrapInner("<div class='lazy-renderer-hidden-content' style='display: none;'></div>");
                    $el.css({
                        height: $el.data("lazy-renderer-forced-height"),
                    });
                }
            }
            static renderElement($el, hiddenItemCssClass, renderedItemCssClass) {
                if ($el.hasClass(hiddenItemCssClass)) {
                    $el.removeClass(hiddenItemCssClass);
                    $el.addClass(renderedItemCssClass);
                    $el.css({
                        height: "auto",
                    });
                    $el.find(".lazy-renderer-hidden-content").contents().unwrap();
                }
            }
        }
        Helper.LazyRenderer = LazyRenderer;
        function removeInlineStyleProps($element, cssProps) {
            cssProps.forEach((cssProp) => {
                $element.css(cssProp, "");
            });
        }
        Helper.removeInlineStyleProps = removeInlineStyleProps;
        function enableButton($button) {
            if ($button && $button.length) {
                $button.css("opacity", "1");
                $button.removeAttr("disabled");
                $button.removeClass("button--disabled");
                $button.removeClass("disabled");
            }
        }
        Helper.enableButton = enableButton;
        function enableButtons(buttons) {
            if (buttons && buttons.length) {
                buttons.forEach((button) => {
                    enableButton($(button));
                });
            }
        }
        Helper.enableButtons = enableButtons;
        function disableButton($button) {
            if ($button && $button.length) {
                $button.css("opacity", "0.5");
                $button.prop("disabled", "true");
                $button.addClass("button--disabled");
                $button.addClass("disabled");
            }
        }
        Helper.disableButton = disableButton;
        function disableButtons(buttons) {
            if (buttons && buttons.length) {
                buttons.forEach((button) => {
                    disableButton($(button));
                });
            }
        }
        Helper.disableButtons = disableButtons;
        function hideButton($button) {
            if ($button && $button.length) {
                $button.hide();
            }
        }
        Helper.hideButton = hideButton;
        function hideButtons(buttons) {
            if (buttons && buttons.length) {
                buttons.forEach((button) => {
                    hideButton($(button));
                });
            }
        }
        Helper.hideButtons = hideButtons;
        function showButton($button) {
            if ($button && $button.length) {
                $button.show();
            }
        }
        Helper.showButton = showButton;
        function showButtons(buttons) {
            if (buttons && buttons.length) {
                buttons.forEach((button) => {
                    showButton($(button));
                });
            }
        }
        Helper.showButtons = showButtons;
        function buttonIsDisabled($button) {
            if (!$button.length)
                return false;
            if ($button.hasClass("disabled") || $button.hasClass("button--disabled"))
                return true;
            const disabledAttr = $button.attr("disabled");
            if (disabledAttr && disabledAttr.trim() != "false")
                return true;
            return false;
        }
        Helper.buttonIsDisabled = buttonIsDisabled;
        function RoundWithDecimals(value, decimalsCount) {
            return value.toFixed(decimalsCount);
        }
        Helper.RoundWithDecimals = RoundWithDecimals;
    })(Helper = CS.Helper || (CS.Helper = {}));
})(CS || (CS = {}));
function parseBool(value) {
    if (value) {
        value = value.toLowerCase();
        return value == "true";
    }
    return false;
}

//# sourceMappingURL=cs-helper.js.map
